<template>
  <main class="wrapper-content">
    <LmDataTable ref="datatable" :slug="$route.params.slug || slug" />
  </main>
</template>

<script>
import LmDataTable from '@/components/lmDataTable/table'

export default {
  components: {
    LmDataTable
  },
  props: {
    slug: {
      type: String,
      default: null
    }
  }
}
</script>
